import { render, staticRenderFns } from "./MemberSettingDialog.vue?vue&type=template&id=3a28d53e&scoped=true&"
import script from "./MemberSettingDialog.vue?vue&type=script&lang=js&"
export * from "./MemberSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./MemberSettingDialog.vue?vue&type=style&index=0&id=3a28d53e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a28d53e",
  null
  
)

export default component.exports